export const FETCH_PLANS = "FETCH_PLANS";
export const FETCH_PLANS_SUCCESS = "FETCH_PLANS_SUCCESS";
export const FETCH_PLANS_FAIL = "FETCH_PLANS_FAIL";